rdefine('app/products/models/Variant',['backbone','app/products/models/Product'],function(Backbone,Product) {
    return Backbone.Ribs.Model.extend({
        defaults:{
            active:false,
            size:0,
            cform:{lang:{}}
        },
        initialize:function() {
            this.collection.on("add reset remove",function(){
                this.set("size",this.collection?this.collection.length:0);
            }.bind(this));
            this.set("size",this.collection.length);
            //this.set("cform",new Product(this.get('cform',{})));
        }
    });
});